import UIkit from 'uikit';

export enum ENotifyTypes {
  primary = 'primary',
  success = 'success',
  warning = 'warning',
  danger = 'danger'
}

export enum ENotifyPos {
  TOP_LEFT = 'top-left',
  TOP_CENTER = 'top-center',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_RIGHT = 'bottom-right',
}

export default function notify({type = ENotifyTypes.primary, message, position}: { type: ENotifyTypes, message: string, position: ENotifyPos }) {
  return UIkit.notification(message, {pos: position, status: type})
}
